/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Csv_Import_HintInputs */

const en_statement_tree_csv_import_hint = /** @type {(inputs: Statement_Tree_Csv_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replaces the current draft rows. Required columns: StatementType, Sign, Level1, Level2. Optional: Level3, RowId, Code. Use BS (balance sheet) or PL (profit and loss) for StatementType, and 1 or +1 (debit) or -1 (credit) for Sign. RowId must be unique when provided; otherwise it is generated on save. Use Save or Create to keep the imported rows.`)
};

const nl_statement_tree_csv_import_hint = /** @type {(inputs: Statement_Tree_Csv_Import_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervangt de huidige conceptregels. Verplichte kolommen: StatementType, Sign, Level1, Level2. Optioneel: Level3, RowId, Code. Gebruik BS (balans) of PL (winst-en-verliesrekening) voor StatementType en 1 of +1 (debet) of -1 (credit) voor Sign. RowId moet uniek zijn als het is ingevuld; anders wordt het bij het opslaan gegenereerd. Gebruik Opslaan of Aanmaken om de geïmporteerde regels te bewaren.`)
};

/**
* | output |
* | --- |
* | "Replaces the current draft rows. Required columns: StatementType, Sign, Level1, Level2. Optional: Level3, RowId, Code. Use BS (balance sheet) or PL (profit a..." |
*
* @param {Statement_Tree_Csv_Import_HintInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_csv_import_hint = /** @type {((inputs?: Statement_Tree_Csv_Import_HintInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Csv_Import_HintInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_csv_import_hint(inputs)
	return en_statement_tree_csv_import_hint(inputs)
});